import ApiService from "@/common/api.service"

export const CourseServcie = {
    async create(params) {
        return ApiService.post("courses/add", params);
    },
    async update(slug, params) {
        return ApiService.update("/courses", slug, params);
    },
    async delete(slug, params) {
        return ApiService.delete("/courses/delete", slug, params);
    },
    async getCourseList(page, itemsPerPage, query) {
        let queryParam = query ? `/courses?page=${page}&pageSize=${itemsPerPage}${query}` : `/courses?page=${page}&pageSize=${itemsPerPage}`
        const res = await ApiService.get(queryParam);
        return res.data
    },

    async getCourses(query) {
        let queryParam = `/courses${query}`;
        const res = await ApiService.get(queryParam);
        return res.data
    }
}